import {
  Box,
  Card,
  Grid,
  MenuItem,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Avatar,
  IconButton,
  Button,
  Stack,
  Skeleton,
  InputAdornment,
  Drawer,
} from "@mui/material";
import { TablePagination } from "@mui/material";
import React, { useState, useEffect } from "react";
import {
  EventNote,
  HowToReg,
  Memory,
  ReportProblem,
  Refresh,
  Settings,
  Visibility,
  Wifi,
} from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import FilterListIcon from "@mui/icons-material/FilterList";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker, DesktopDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import SearchIcon from "@mui/icons-material/Search";
function Audit() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobile]);

  const [value, setValue] = useState("All Event Types");
  const [status, setStatus] = useState("All Severity");
  const [date, setDate] = useState("All");
  //   const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [searchText, setSearchText] = useState("");
  const DEFAULT_EVENT = "All Event Types";
  const DEFAULT_SEVERITY = "All Severity";
  const DEFAULT_DATE = "All";
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const showResetButton =
    value !== DEFAULT_EVENT ||
    status !== DEFAULT_SEVERITY ||
    date !== DEFAULT_DATE ||
    searchText !== "";
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });
  const cards = [
    {
      icon: <EventNote sx={{ color: "#1976d2" }} />,
      bg: "#e3f2fd",
      count: "Today",
      countColor: "#1976d2",
      title: "Total Events",
      value: "2,847",
    },
    {
      icon: <HowToReg sx={{ color: "#16a34a" }} />,
      bg: "#dcfce7",
      count: "+15%",
      countColor: "#22c55e",
      title: "User Actions",
      value: "1,523",
    },
    {
      icon: <Memory sx={{ color: "#9333ea" }} />,
      bg: "#eee2f1ff",
      count: "+8%",
      countColor: "#9333ea",
      title: "Device Events",
      value: "1,124",
    },
    {
      icon: <ReportProblem sx={{ color: "#ea580c" }} />,
      bg: "#fee2e2",
      count: "-12%",
      countColor: "#ea580c",
      title: "Security Events",
      value: "200",
    },
  ];

  const logs = [
    {
      timestamp: "2024-12-11 14:23:45",
      type: "User Login",
      icon: <HowToReg color="primary" />,
      user: "Admin User",
      action: "Successful login",
      target: "Dashboard",
      severity: "Info",
      ip: "192.168.1.100",
    },
    {
      timestamp: "2024-12-11 14:21:32",
      type: "Device Action",
      icon: <Memory color="secondary" />,
      user: "Temp Sensor 01",
      action: "Configuration updated",
      target: "TS-2024-001",
      severity: "Info",
      ip: "10.0.1.15",
    },
    {
      timestamp: "2024-12-11 14:08:56",
      type: "Connectivity",
      icon: <Wifi color="#ff0000" />,
      user: "Smart Light 45",
      action: "Connection lost",
      target: "SL-2024-045",
      severity: "Warning",
      ip: "10.0.1.45",
    },
  ];

  const [filteredLogs, setFilteredLogs] = useState(logs);
  const hasActiveFilters =
    value !== DEFAULT_EVENT ||
    status !== DEFAULT_SEVERITY ||
    date !== DEFAULT_DATE;
  useEffect(() => {
    if (!logs || logs.length === 0) {
      setFilteredLogs([]);
      return;
    }

    let data = [...logs];

    if (searchText.trim() !== "") {
      const q = searchText.toLowerCase();

      data = data.filter((log) =>
        Object.values(log).some((value) =>
          String(value).toLowerCase().includes(q),
        ),
      );
    }

    if (value !== "All Event Types") {
      data = data.filter((log) => log.type === value);
    }

    if (status !== "All Severity") {
      data = data.filter((log) => log.severity === status);
    }

    const now = dayjs();

    if (date === "Last 24 Hours") {
      data = data.filter((log) =>
        dayjs(log.timestamp).isAfter(now.subtract(24, "hour")),
      );
    } else if (date === "Last 7 Days") {
      data = data.filter((log) =>
        dayjs(log.timestamp).isAfter(now.subtract(7, "day")),
      );
    } else if (date === "Last 30 Days") {
      data = data.filter((log) =>
        dayjs(log.timestamp).isAfter(now.subtract(30, "day")),
      );
    } else if (date === "Custom Range" && startDate && endDate) {
      data = data.filter((log) =>
        dayjs(log.timestamp).isBetween(startDate, endDate, "day", "[]"),
      );
    }

    setFilteredLogs(data);
  }, [searchText, value, status, date, startDate, endDate]);
  const paginatedLogs = filteredLogs.slice(
    paginationModel.page * paginationModel.pageSize,
    paginationModel.page * paginationModel.pageSize + paginationModel.pageSize,
  );
  const DetailRow = ({ label, value, last }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      py: 1.8,
      borderBottom: last ? "none" : "1px solid #e5e7eb",
    }}
  >
    {/* Label */}
    <Typography
      sx={{
        fontSize: "14px",
        color: "#6b7280",
        fontWeight: 500,
      }}
    >
      {label}
    </Typography>

    {/* Value */}
    <Typography
      sx={{
        fontSize: "15px",
        fontWeight: 600,
        color: "#111827",
      }}
    >
      {value || "—"}
    </Typography>
  </Box>
);
  return (
    <Box
      sx={{
        minHeight: "100%",
        pt: { xs: 5, sm: 5, md: 3 },
        pb: 4,
        px: { xs: 2, md: 3 },

        background:
          "radial-gradient(circle at top left, rgba(14, 165, 233, 0.14), transparent 30%), radial-gradient(circle at top right, rgba(16, 185, 129, 0.12), transparent 28%), linear-gradient(180deg, #f8fbff 0%, #eef4f8 100%)",
      }}
    >
      <Box
        sx={{
          position: "relative",
          overflow: "hidden",
          mb: 4,
          px: { xs: 2, md: 3 },
          py: { xs: 3, md: 4 },
          borderRadius: 5,

          background:
            "linear-gradient(135deg, rgba(15, 23, 42, 0.96), rgba(15, 118, 110, 0.88) 55%, rgba(8, 47, 73, 0.92))",

          boxShadow: "0 30px 80px rgba(15, 23, 42, 0.25)",
        }}
      >
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          spacing={2}
          mb={4}
        >
          <Box>
            <Typography variant="h4" fontWeight={700} color="#fff">
              Audit Logs
            </Typography>
          </Box>
        </Stack>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(4, 1fr)",
            },
            gap: 3,
            mb: 1,
          }}
        >
          {cards.map((card, index) => (
            <Card
              key={index}
              onClick={() => {
                setSelectedRow(card);
                setOpenDrawer(true);
              }}
              sx={{
                borderRadius: 7,
                p: 2,

                backgroundColor: "rgba(255,255,255,0.08)",
                border: "1px solid rgba(255,255,255,0.15)",
                backdropFilter: "blur(12px)",

                color: "#fff",

                transition: "all 0.25s ease",
              }}
            >
              {/* Top section */}
              <Box display="flex" justifyContent="space-between">
                <Box
                  sx={{
                    width: 52,
                    height: 52,
                    borderRadius: "12px",
                    backgroundColor: card.bg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {card.icon}
                </Box>

                <Typography
                  sx={{
                    color: card.bg,
                    fontWeight: 600,
                    fontSize: "14px",
                  }}
                >
                  {card.count}
                </Typography>
              </Box>

              {/* Bottom */}
              <Box>
                <Typography
                  sx={{
                    mt: 2,
                    color: card.bg,
                    fontSize: "14px",
                  }}
                >
                  {card.title}
                </Typography>

                <Typography
                  sx={{
                    mt: 0.5,
                    fontSize: "22px",
                    fontWeight: 700,
                    color: card.bg,
                  }}
                >
                  {card.value}
                </Typography>
              </Box>
            </Card>
          ))}
        </Box>
      </Box>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Card
          sx={{
            mt: 3,
            borderTopLeftRadius: "20px",
borderTopRightRadius: "20px",
            width: "100%",
            overflow: "hidden",

            background: "rgba(255,255,255,0.06)",
            border: "1px solid rgba(255,255,255,0.12)",
            backdropFilter: "blur(14px)",
            // borderRadius: 5,

            background:
              "linear-gradient(135deg, rgba(15, 23, 42, 0.96), rgba(15, 118, 110, 0.88) 55%, rgba(8, 47, 73, 0.92))",

            boxShadow: "0 30px 80px rgba(15, 23, 42, 0.25)",
          }}
        >
          <Box
            p={2}
            borderBottom="1px solid rgba(148, 163, 184, 0.18)"
            display="flex"
            flexWrap="wrap"
            alignItems="center"
            gap={2}
            sx={{
              background:
                "linear-gradient(135deg, rgba(15, 23, 42, 0.96), rgba(15, 118, 110, 0.88) 55%, rgba(8, 47, 73, 0.92))",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
                alignItems: "center",
              }}
            >
              {/* Event Type */}
              <TextField
                select
                size="small"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                sx={{
                  width: { xs: "100%", md: 140 },
                  borderRadius: 1,
                  "& .MuiInputLabel-root": {
                    color: "rgba(203, 213, 225, 0.75)",
                  },
                  "& .MuiInputLabel-root.Mui-focused": { color: "#5eead4" },
                  "& .MuiOutlinedInput-root": {
                    color: "#e2f8f5",
                    "& fieldset": { borderColor: "rgba(148, 163, 184, 0.25)" },
                    "&:hover fieldset": {
                      borderColor: "rgba(148, 163, 184, 0.45)",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "rgba(20, 184, 166, 0.6)",
                    },
                  },
                  "& .MuiSelect-icon": { color: "rgba(203, 213, 225, 0.70)" },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <FilterListIcon
                        fontSize="small"
                        sx={{ color: "rgba(203, 213, 225, 0.60)" }}
                      />
                    </InputAdornment>
                  ),
                }}
              >
                <MenuItem value="All Event Types">Event Types</MenuItem>
                <MenuItem value="User Login">User Login</MenuItem>
                <MenuItem value="Device Action">Device Action</MenuItem>
              </TextField>

              {/* Severity */}
              <TextField
                select
                size="small"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                sx={{
                  width: { xs: "100%", md: 140 },
                  borderRadius: 1,
                  "& .MuiInputLabel-root": {
                    color: "rgba(203, 213, 225, 0.75)",
                  },
                  "& .MuiInputLabel-root.Mui-focused": { color: "#5eead4" },
                  "& .MuiOutlinedInput-root": {
                    color: "#e2f8f5",
                    "& fieldset": { borderColor: "rgba(148, 163, 184, 0.25)" },
                    "&:hover fieldset": {
                      borderColor: "rgba(148, 163, 184, 0.45)",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "rgba(20, 184, 166, 0.6)",
                    },
                  },
                  "& .MuiSelect-icon": { color: "rgba(203, 213, 225, 0.70)" },
                  "& input[type='date']::-webkit-calendar-picker-indicator": {
                    filter: "invert(1) opacity(0.6)",
                    cursor: "pointer",
                    
                  },
                }}
                InputLabelProps={{ shrink: true }}
              >
                <MenuItem value="All Severity">Severity</MenuItem>
                <MenuItem value="Info">Info</MenuItem>
              </TextField>

              {/* Date Range */}
              <TextField
                select
                size="small"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                sx={{
                  width: { xs: "100%", md: 140 },
                  borderRadius: 1,
                  "& .MuiInputLabel-root": {
                    color: "rgba(203, 213, 225, 0.75)",
                  },
                  "& .MuiInputLabel-root.Mui-focused": { color: "#5eead4" },
                  "& .MuiOutlinedInput-root": {
                    color: "#e2f8f5",
                    "& fieldset": { borderColor: "rgba(148, 163, 184, 0.25)" },
                    "&:hover fieldset": {
                      borderColor: "rgba(148, 163, 184, 0.45)",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "rgba(20, 184, 166, 0.6)",
                    },
                  },
                  "& .MuiSelect-icon": { color: "rgba(203, 213, 225, 0.70)" },
                  "& input[type='date']::-webkit-calendar-picker-indicator": {
                    filter: "invert(1) opacity(0.6)",
                    cursor: "pointer",
                  },
                }}
                InputLabelProps={{ shrink: true }}
              >
                <MenuItem value="All">Date Range</MenuItem>
                <MenuItem value="Last 7 Days">Last 7 Days</MenuItem>
              </TextField>
              {/* Reset Button */}
              {hasActiveFilters && (
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    setValue(DEFAULT_EVENT);
                    setStatus(DEFAULT_SEVERITY);
                    setDate(DEFAULT_DATE);
                  }}
                  sx={{
                    textTransform: "none",
                    fontSize: 12,
                    height: 38,
                    color: "#fff",
                    borderColor: "rgba(148, 163, 184, 0.45)",
                    background: "rgba(239, 68, 68, 0.10)",
                    "&:hover": {
                      borderColor: "rgba(20, 184, 166, 0.6)",
                      background: "rgba(239, 68, 68, 0.18)",
                    },
                  }}
                >
                  Reset filters
                </Button>
              )}
 </Box>
              {/* Search */}
              <TextField
                size="small"
                placeholder="Search..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
               sx={{
  width: { xs: "100%", sm: 260 },  
  borderRadius: 1,

  ml: { xs: 0, sm: "auto" },

  "& .MuiOutlinedInput-root": {
    color: "#e2f8f5",
    "& fieldset": { borderColor: "rgba(148, 163, 184, 0.25)" },
    "&:hover fieldset": {
      borderColor: "rgba(148, 163, 184, 0.45)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "rgba(20, 184, 166, 0.6)",
    },
  },

  "& .MuiInputBase-input::placeholder": {
    color: "rgba(148, 163, 184, 0.55)",
    opacity: 1,
  },
}}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: "#fff" }} />
                    </InputAdornment>
                  ),

                  //  CLOSE ICON 
                  endAdornment: searchText && (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => setSearchText("")}
                        sx={{
                          color: "rgba(203, 213, 225, 0.7)",
                          p: 0.3,
                          "&:hover": {
                            color: "#fff",
                            background: "rgba(255,255,255,0.1)",
                          },
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
           
          </Box>
        </Card>
      </LocalizationProvider>
      {/* <Box
        mt={2}
        px={2}
        py={1.5}
        display={isMobile ? "flex-wrap" : "flex"}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid #e5e7eb"
      >
        <Box display="flex" alignItems="center" gap={2}>
          <Typography fontSize="18px" fontWeight={600}>
            Activity Logs
          </Typography>
          <Chip label="2,847 events" size="small" />
        </Box>

        <Box>
          <IconButton>
            <Refresh />
          </IconButton>
          <IconButton>
            <Settings />
          </IconButton>
        </Box>
      </Box> */}

      <TableContainer
        sx={{
          overflowX: "auto",

          maxWidth: "100%",
          width: isMobile ? "21.875rem" : "auto",
        }}
      >
        <Table
          sx={{
            minWidth: isMobile ? "15.625rem" : "40.625rem",
            borderCollapse: "separate",
            borderSpacing: 0,

            "& .MuiTableHead-root": {
              backgroundColor: "#f1f5f9", 
            },

            "& .MuiTableCell-head": {
              color: "#475569",
              fontWeight: 600,
              fontSize: "13px",
              borderBottom: "1px solid #e2e8f0",
              position: "relative",
            },

            // vertical divider like screenshot
            "& .MuiTableCell-head:not(:last-child)::after": {
              content: '""',
              position: "absolute",
              right: 0,
              top: "25%",
              height: "50%",
              width: "1px",
              backgroundColor: "#e2e8f0",
            },

            "& .MuiTableCell-body": {
              borderBottom: "1px solid #e2e8f0",
              color: "#334155",
              fontSize: "14px",
            },

            "& .MuiTableRow-root:hover": {
              backgroundColor: "#f8fafc",
            },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>Timestamp</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>User/Device</TableCell>
              <TableCell>Action</TableCell>
              <TableCell>Target</TableCell>
              <TableCell>Severity</TableCell>
              <TableCell>IP Address</TableCell>
              <TableCell>Details</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {paginatedLogs.map((log, index) => (
              <TableRow key={index} hover>
                <TableCell>{log.timestamp}</TableCell>

                <TableCell>
                  <Box display="flex" alignItems="center" gap={1}>
                    {log.icon}
                    <Typography fontSize="14px">{log.type}</Typography>
                  </Box>
                </TableCell>

                <TableCell>
                  <Box display="flex" alignItems="center" gap={1.5}>
                    <Avatar sx={{ width: 32, height: 32 }}>
                      {log.user.charAt(0)}
                    </Avatar>
                    <Typography fontSize="14px">{log.user}</Typography>
                  </Box>
                </TableCell>

                <TableCell>{log.action}</TableCell>
                <TableCell>{log.target}</TableCell>

                <TableCell>
                  <Chip
                    label={log.severity}
                    size="small"
                    color="info"
                    sx={{ fontWeight: 500 }}
                  />
                </TableCell>

                <TableCell>{log.ip}</TableCell>

                <TableCell align="center">
                  <IconButton
                    onClick={() => {
                      setSelectedRow(log); // store clicked row
                      setOpenDrawer(true); // open drawer
                    }}
                  >
                    <Visibility />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Drawer
          anchor="right"
          open={openDrawer}
          onClose={() => setOpenDrawer(false)}
        >
          <Box
            sx={{
              width: { xs: "100vw", sm: 400 },
              height: "100%",
              display: "flex",
              flexDirection: "column",

              color: "#e2f8f5",
            }}
          >
            {/* 🔹 HEADER */}
            <Box
              sx={{
                p: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid rgba(148,163,184,0.2)",
                background:
                  "linear-gradient(135deg, rgba(15, 23, 42, 0.96), rgba(15, 118, 110, 0.88) 55%, rgba(8, 47, 73, 0.92))",
                backdropFilter: "blur(14px)",
              }}
            >
              <Typography variant="h6" fontWeight={600}>
                Log Details
              </Typography>

              <IconButton
                onClick={() => setOpenDrawer(false)}
                sx={{
                  color: "#e2f8f5",
                  "&:hover": { background: "rgba(255,255,255,0.1)" },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            {/* 🔹 CONTENT */}
            <Box sx={{ p: 2, overflowY: "auto", flex: 1 }}>
              <DetailRow label="Timestamp" value={selectedRow?.timestamp} />
              <DetailRow label="Type" value={selectedRow?.type} />
              <DetailRow label="User" value={selectedRow?.user} />
              <DetailRow label="Action" value={selectedRow?.action} />
              <DetailRow label="Target" value={selectedRow?.target} />
              <DetailRow label="Severity" value={selectedRow?.severity} />
              <DetailRow label="IP Address" value={selectedRow?.ip} />
            </Box>
          </Box>
        </Drawer>
      </TableContainer>
      <TablePagination
        component="div"
        count={filteredLogs.length}
        page={paginationModel.page}
        onPageChange={(e, newPage) =>
          setPaginationModel((prev) => ({ ...prev, page: newPage }))
        }
        rowsPerPage={paginationModel.pageSize}
        onRowsPerPageChange={(e) =>
          setPaginationModel({
            page: 0,
            pageSize: parseInt(e.target.value, 10),
          })
        }
        rowsPerPageOptions={[5, 10, 20, 50]}
        sx={{
          color: "#404a48ff",
          borderTop: "1px solid rgba(148, 163, 184, 0.2)",
          "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
            { color: "#404a48ff" },
          "& .MuiSvgIcon-root": { color: "#404a48ff" },
        }}
      />
    </Box>
  );
}

export default Audit;
